import { GUID, Param } from "app/brightserve/brightserve.module";

export class Address {
	Id: GUID;
	SubBuilding: string;
	BuildingName: string;
	BuildingNumber: string;
	PrimaryStreet: string;
	SecondaryStreet: string;
	DependentLocality: string;
	DoubleDependentLocality: string;
	PostTown: string; //
	County: string;
	Postcode: string;
	Country: string;

	Type: Param;

	ForDisplay: string;
	Abbreviated: string;

	constructor(init?: Partial<Address>) {
		this.Id = GUID.newGuid();
		Object.assign(this, init);

		if (init && init.Type) {
			this.Type = new Param(init.Type);
		} else {
			this.Type = new Param();
		};
	};

	HasAddress() {
		if (this.SubBuilding || this.BuildingName || this.BuildingNumber || this.PrimaryStreet || this.SecondaryStreet || this.DependentLocality || this.DoubleDependentLocality || this.PostTown || this.County || this.Postcode || this.Country)
			return true;
		return false;
	};
}


// WEBPACK FOOTER //
// ./src/app/brightserve/address.ts